// extracted by mini-css-extract-plugin
export var content = "_dg-3";
export var list = "_dg-4";
export var settingsContent = "_dg-7";
export var settingsPanel = "_dg-8";
export var state = "_dg-6";
export var triggerBadge = "_dg-2";
export var triggerButton = "_dg-1";
export var triggerShell = "_dg-0";
export var unreadDot = "_dg-5";